import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { withLangPrefix } from '../../../helpers/links';

export default function ListingBreadcrumbs() {
  const listing = useSelector((state) => state.listing);
  const env = useSelector((state) => state.env);
  const { userLanguage } = env || {};
  const lang = userLanguage || 'en';
  let route = '/search';

  return (
    <h2 className="m-0">
      {
        listing._meta.breadcrumbs.length > 0 && (lang === 'en' || lang === 'fr' || !lang) ? (
          <ol
            className="breadcrumbs list-none flex items-center p-0 m-0"
            itemScope
            itemType="http://schema.org/BreadcrumbList"
          >
            {
              listing._meta.breadcrumbs.map((crumb, index) => {
                route += `/${crumb.slug}`;
                const finalRoute = `${route}${listing._meta.primaryUseCase.slug === 'all' ? '' : '/' + listing._meta.primaryUseCase.slug}`;
                return (
                  <Fragment key={`listing-breadcrumbs-${index}`}>
                    {(index > 0) && (
                      <li className="p-0 hidden text-stone-900 lg:flex items-center">
                        <ChevronRightIcon width={16} />
                      </li>
                    )}

                    <li className={`p-0 ${index < (listing._meta.breadcrumbs.length - 1) && 'hidden lg:block'}`}
                        itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                      <a
                        className="underline underline-offset-2 decoration-1 text-base font-light text-neutral-900 hover:text-neutral-700"
                        href={withLangPrefix(finalRoute, userLanguage)}
                        itemProp="item"
                        target="_self"
                      >
                        <div className="first-letter:uppercase" itemProp="name">
                          {listing._meta.primaryUseCase.marketLabel} {(lang === 'en' || !lang) ? `in ${crumb.name}` : `à ${crumb.translatedName.fr}`}
                        </div>
                        <meta itemProp="position" content={index}/>
                      </a>
                    </li>
                  </Fragment>
                );
              })
            }
          </ol>
        ) : listing.neighborhood && (
          <div className="text-base font-light text-neutral-900">
            {listing.neighborhood}&nbsp;&ndash;&nbsp;{listing._meta.locationName}
          </div>
        )
      }
    </h2>
  );
}
